module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o2o-helper"
  }, [(_vm.hasArrow) ? _c('div', {
    staticClass: "info f-strong",
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._v(_vm._s(_vm.text.a1) + "\n        "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show),
      expression: "!show"
    }],
    staticClass: "arr-gray-down"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "arr-gray-up"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "help clearfix"
  }, [_c('div', {
    staticClass: "introduce-info"
  }, [_c('div', {
    staticClass: "f-minor"
  }, [_vm._v(_vm._s(_vm.text.a3))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "f-minor"
  }, [_vm._v(_vm._s(_vm.text.a4))])]), _vm._v(" "), _c('div', {
    staticClass: "zhj-img"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f312c0f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/O2OHelper.vue
// module id = 799
// module chunks = 0